import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

class CustomCombinator extends Component {
  render() {
    return (
        <div className="combinator-div ">
        <button className="ruleGroup-addRule btn btn-primary btn-sm combinator-button">
          {this.props.t("andCombinator")}
        </button>
      </div>
    );
  }
}

CustomCombinator.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(CustomCombinator);